module.exports = __webpack_public_path__ + "img/ios-install-step-3.f9188f50.svg";